import { Component, ChangeDetectionStrategy, Input, OnChanges, SimpleChanges, ViewChildren, QueryList, ViewChild } from '@angular/core';
import { TransactionsData } from '../../transactions.models';
import * as moment from 'moment';
import { ColumnDef, TableHeader } from '../../../../global/interfaces';
// import { MosAccordionComponent } from 'merceros-ui-components';
import { TransactionsDetailsComponent } from '../../transactions-details/transactions-details.component';
import { TableColumnAlignment } from 'atlas-table';

@Component({
  standalone: false,
  selector: 'dsp-transactions-accordion',
  templateUrl: 'transactions-accordion.component.html',
  styleUrls: ['transactions-accordion.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TransactionsAccordionComponent implements OnChanges {
  // @ViewChildren(MosAccordionComponent)
  // public accordions: QueryList<MosAccordionComponent>;

  @ViewChild(TransactionsDetailsComponent)
  public modal: TransactionsDetailsComponent;

  @Input() public data: TransactionsData[] = [];

  @Input() public lastSelection: string;

  @Input() public from: string;

  @Input() public to: string;
  @Input() public country: string;

  @Input() public accountId: string;

  // public headers: TableHeader[] = [
  //   {
  //     name: 'Date',
  //     column: 'date'
  //   },
  //   {
  //     name: 'Description',
  //     column: 'description',
  //   },
  //   {
  //     name: 'Amount Currency',
  //     column: 'amount',
  //     textAlign: 'right'
  //   },
  //   {
  //     name: 'Unit Price*',
  //     column: 'unitPrice',
  //     textAlign: 'right'
  //   },
  //   {
  //     name: 'Units',
  //     column: 'units',
  //     textAlign: 'right'
  //   },
  //   {
  //     name: 'Unit Balance',
  //     column: 'unitBalance',
  //     textAlign: 'right'
  //   }
  // ];
  // public headersNZ: TableHeader[] = [
  //   {
  //     name: 'Date',
  //     column: 'date'
  //   },
  //   {
  //     name: 'Description',
  //     column: 'description',
  //   },
  //   {
  //     name: 'Gross Contributions / Withdrawals',
  //     column: 'grossContributionsWithdrawals',
  //     textAlign: 'right'
  //   },
  //   {
  //     name: 'PIE Tax Paid/Rebated',
  //     column: 'pieTaxPaid',
  //     textAlign: 'right'
  //   },
  //   {
  //     name: 'Net Contributions / Withdrawals',
  //     column: 'netContributionsWithdrawals',
  //     textAlign: 'right'
  //   },
  //   {
  //     name: 'Unit Price*',
  //     column: 'unitPrice',
  //     textAlign: 'right'
  //   },
  //   {
  //     name: 'Units',
  //     column: 'units',
  //     textAlign: 'right'
  //   },
  //   {
  //     name: 'Unit Balance',
  //     column: 'unitBalance',
  //     textAlign: 'right'
  //   }
  // ];
  public dataDummy = [{
    name: 'Date',
    column: 'date',
    sortable: false,
    displayLabel: 'Date',
    fieldKey: 'date',

  },
  {
    name: 'Description',
    column: 'description',
    sortable: false,
    displayLabel: 'Description',
    fieldKey: 'description',


  },
  {
    name: 'Amount Currency',
    column: 'amount',
    align: TableColumnAlignment.right,
    sortable: false,
    displayLabel: 'Amount Currency',
    fieldKey: 'amount',

  },
  ]

  public headers: ColumnDef[] = [
    {
      name: 'Date',
      column: 'date',
      sortable: false,
      displayLabel: 'Date',
      fieldKey: 'date',

    },
    {
      name: 'Description',
      column: 'description',
      sortable: false,
      displayLabel: 'Description',
      fieldKey: 'description',


    },
    {
      name: 'Amount Currency',
      column: 'amount',
      align: TableColumnAlignment.right,
      sortable: false,
      displayLabel: 'Amount Currency',
      fieldKey: 'amount',

    },
    {
      name: 'Unit Price*',
      column: 'unitPrice',
      align: TableColumnAlignment.right,
      sortable: false,
      displayLabel: 'Unit Price*',
      fieldKey: 'unitPrice',


    },
    {
      name: 'Units',
      column: 'units',
      align: TableColumnAlignment.right,
      sortable: false,
      displayLabel: 'Units',
      fieldKey: 'units',


    },
    {
      name: 'Unit Balance',
      column: 'unitBalance',
      align: TableColumnAlignment.right,
      sortable: false,
      displayLabel: 'Unit Balance',
      fieldKey: 'unitBalance',

    }
  ];
  public headersNZ: ColumnDef[] = [
    {
      name: 'Date',
      column: 'date',
      sortable: false,
      displayLabel: 'Date',
      fieldKey: 'date',

    },
    {
      name: 'Description',
      column: 'description',
      sortable: false,
      displayLabel: 'Description',
      fieldKey: 'description',

    },
    {
      name: 'Gross Contributions / Withdrawals',
      column: 'grossContributionsWithdrawals',
      align: TableColumnAlignment.right,
      sortable: false,
      displayLabel: 'Gross Contributions / Withdrawals',
      fieldKey: 'grossContributionsWithdrawals',
    },
    {
      name: 'PIE Tax Paid/Rebated',
      column: 'pieTaxPaid',
      align: TableColumnAlignment.right,
      sortable: false,
      displayLabel: 'PIE Tax Paid/Rebated',
      fieldKey: 'pieTaxPaid',

    },
    {
      name: 'Net Contributions / Withdrawals',
      column: 'netContributionsWithdrawals',
      align: TableColumnAlignment.right,
      sortable: false,
      displayLabel: 'Net Contributions / Withdrawals',
      fieldKey: 'netContributionsWithdrawals',

    },
    {
      name: 'Unit Price*',
      column: 'unitPrice',
      align: TableColumnAlignment.right,
      sortable: false,
      displayLabel: 'Unit Price*',
      fieldKey: 'unitPrice',

    },
    {
      name: 'Units',
      column: 'units',
      align: TableColumnAlignment.right,
      sortable: false,
      displayLabel: 'Units',
      fieldKey: 'units',

    },
    {
      name: 'Unit Balance',
      column: 'unitBalance',
      align: TableColumnAlignment.right,
      sortable: false,
      displayLabel: 'Unit Balance',
      fieldKey: 'unitBalance',

    }
  ];
  // public ngOnChanges(changes: SimpleChanges): void {
  //   if (!!changes.data && !!this.accordions && !!this.accordions.length) {
  //     this.accordions.first.expanded = true;
  //   }
  // }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.data && this.data && this.data.length > 0) {
      // Initialize expanded property for each item if not already set
      this.data.forEach((item, index) => {
        if (item.expanded === undefined) {
          item.expanded = index === 0; // Open first item by default, rest collapsed
        }
      });
    }
  }

  public toggleExpanded(index: number): void {
    if (this.data && this.data[index]) {
      this.data[index].expanded = !this.data[index].expanded;
    }
  }

  // noinspection JSMethodCanBeStatic
  public formatDate(date: string, format = 'YYYY-MM-DD'): string {
    if (date && date.length > 11) {
      return moment.utc(date).format(format);
    } else {
      return ' ';
    }

  }

  // noinspection JSMethodCanBeStatic
  public formatId(fund: number, transaction: number, field: string): string {
    return `fund-${fund}-transaction-${transaction}-${field}`;
  }
  public onOpenModal(data): void {
    this.modal.open(data);
  }
}
